// Client-safe constants for the community (group) limit.
export const FREE_GROUP_LIMIT = 5;
export const GROUP_LIMIT_MESSAGE = `Você atingiu o limite de ${FREE_GROUP_LIMIT} comunidades no plano gratuito. Seja Pro para participar de comunidades ilimitadas.`;

export function isGroupLimitError(err: unknown): boolean {
  const msg = err instanceof Error ? err.message : String(err ?? "");
  return msg.includes("limite de") && msg.includes("comunidades");
}
